<rotec-modal-v2 [width]="width" [height]="height" [showCloseIcon]="false">
  <ng-container ngProjectAs="modal-main">
    <div class="main">
      <p class="title">{{ 'Changing the support settings' | translate}}</p>
      <p class="text">
        {{ 'Changing the support settings changes the type data for geometry. All type data
        information will be deleted and must be entered again. Please select how to proceed.' |
        translate}}
      </p>
    </div>
  </ng-container>
  <ng-container ngProjectAs="modal-buttons">
    <button rotec-button-warning (click)="changeSupportSettings()">
      {{ 'Change support settings' | translate}}
    </button>
    <button rotec-button-active translate (click)="abort()">{{ 'Abort' | translate}}</button>
  </ng-container>
</rotec-modal-v2>
